var FilterService = /** @class */ (function () {
    function FilterService($http, $q, ProductService, $state, $stateParams) {
        'ngInject';
        this.brandMap = new Map();
        this.deliveryFormatMap = new Map();
        this.dietaryConsiderationMap = new Map();
        this.taxonomyMap = new Map();
        this.ingredientMap = new Map();
        this.categoryList = [];
        this.filterType = '';
        this.filterValue = '';
        this.filterModel = {};
        this.activeFilters = {};
        this.attributeSubcategoryLookup = {};
        this.subCategoryCategoryLookup = {};
        this.$http = $http;
        this.$q = $q;
        this.ProductService = ProductService;
        this.$state = $state;
        this.$stateParams = $stateParams;
    }
    FilterService.prototype.resetFilterModel = function () {
        this.filterModel = {
            'Categories': {
                'title': 'By Category / Condition',
                'stateParameter': 'c',
                'displayNumber': 0,
                'items': [],
            },
            'Brand': {
                'title': 'By Brand',
                'stateParameter': 'b',
                'displayNumber': 0,
                'items': [],
            },
            'DietaryConsiderations': {
                'title': 'By Dietary Consideration',
                'stateParameter': 'dc',
                'displayNumber': 0,
                'items': [],
            },
            'ActiveIngredients': {
                'title': 'Include Ingredient',
                'stateParameter': 'ii',
                'isIngredient': true,
                'items': [],
                'activeItems': [],
            },
            'Ingredients': {
                'title': 'Exclude Ingredient',
                'stateParameter': 'ei',
                'isIngredient': true,
                'items': [],
                'activeItems': [],
            },
            'EqpStatus': {
                'title': 'By Quality Partner',
                'stateParameter': 'q',
                'displayNumber': 0,
                'items': [],
            },
            'DeliveryFormat': {
                'title': 'By Delivery Format',
                'stateParameter': 'df',
                'displayNumber': 0,
                'items': [],
            },
            'Dosage': {
                'title': 'By Dosage',
                'stateParameter': 'ds',
                'displayNumber': 0,
                'items': [],
            },
        };
    };
    FilterService.prototype.lookupSearchTerm = function (firstFilter, firstFilterType) {
        var match;
        var deferred = this.$q.defer();
        switch (firstFilterType.toLowerCase()) {
            case 'b':
                this.ProductService.getBrands()
                    .then(function (data) {
                    match = data.currentPage.find(function (item) { return item.brandId == firstFilter; });
                    deferred.resolve(match.brand);
                });
                break;
            case 'c':
                this.ProductService.getCategories()
                    .then(function (data) {
                    match = data.find(function (item) { return item.taxonomyId == firstFilter; });
                    deferred.resolve(match.category);
                });
                break;
            default:
                deferred.resolve('*');
                break;
        }
        return deferred.promise;
    };
    /**
     * Create filter model based on filter value and filter type as ff and fft from state parameter.
     * If ff and fft do not change, it is a search based on previous search results (paging/sorting change, toggle more
     * filter etc. Thus the content of filter won't change.
     * @param {string} filterValue
     * @param {string} filterType
     * @return {promise}
     */
    FilterService.prototype.getSearchFacets = function (filterValue, filterType) {
        var _this = this;
        if (filterType) {
            filterType = filterType.toLowerCase();
        }
        var filterQueryData = {};
        var filterParameterList = {
            'a': 'attributes',
            'b': 'brands',
            'c': 'categories',
            's': 'subcategories',
            'dc': 'dietaryConsiderations',
            'df': 'deliveryFormat',
            'ds': 'dosages',
            'q': 'eqpStatuses',
            'ii': 'includeIngredients',
            'ei': 'excludeIngredients'
        };
        // activeFilters represents which filter is active
        Object.keys(filterParameterList)
            .forEach(function (key) {
            if (typeof (_this.$stateParams[key]) === 'string') {
                // single-value parameter needs to be converted into array
                _this.activeFilters[filterParameterList[key]] = [_this.$stateParams[key]] || [];
            }
            else {
                // multi-value parameter is an array
                _this.activeFilters[filterParameterList[key]] = _this.$stateParams[key] || [];
            }
        });
        if (this.$state.current.name === 'searchResults') {
            this.activeFilters[filterParameterList[filterType]] = [filterValue];
        }
        // filterQueryData is the query data for filter facets
        if (filterType === 'term') {
            filterQueryData = { 'searchTerm': filterValue };
        }
        else if (filterType === 'new') {
            filterQueryData['searchTerm'] = '*';
            filterQueryData['isNewProduct'] = !!filterValue;
        }
        else {
            filterQueryData['searchTerm'] = '*';
            filterQueryData[filterParameterList[filterType]] = Array.isArray(filterValue) ? filterValue : [filterValue];
        }
        filterQueryData = Object.assign(filterQueryData, { pageNumber: 1, pageSize: 24 });
        return this.$http.post('/api/search/searchFacets', filterQueryData)
            .then(function (response) {
            if (response && response.data && response.data.response.items) {
                return _this.updateFilterModel(response.data.response.items);
            }
            else {
                return _this.filterModel;
            }
        })
            .catch(function (error) {
            return _this.$q.reject(error);
        });
    };
    /**
     *  Organize filter model content with facets response, set active item with query.
     *  Query contains brands, category, subcategories, dietaryConsiderations, deliveryFormat as array of
     *  numbers.
     *  Query also contains eqpStatuses and dosages as array of string.
     *  @param {object} facets
     *  @return {object} updated filterModel
     */
    FilterService.prototype.updateFilterModel = function (facets) {
        var _this = this;
        var state = this.$stateParams;
        this.resetFilterModel();
        // Mapping facets category/subcategory to filterModel
        var subCategorySet = new Set();
        var attributeSet = new Set();
        facets['Subcategories'].forEach(function (obj) {
            subCategorySet.add(obj.id);
        });
        facets['Attributes'].forEach(function (obj) {
            attributeSet.add(obj.id);
        });
        facets['Categories'].forEach(function (c) {
            var subItemsList = [];
            var expandCategory = false;
            _this.categoryList.forEach(function (category) {
                if (category.taxonomyId === c.id) {
                    category['subCategory'].forEach(function (subCategory) {
                        if (subCategorySet.has(subCategory.taxonomyId)) {
                            var attributeList_1 = [];
                            var expandSubcategory_1 = false;
                            if ('attribute' in subCategory) {
                                subCategory['attribute'].forEach(function (attribute) {
                                    if (attributeSet.has(attribute.taxonomyId)) {
                                        var isAttributeActive = _this.activeFilters['attributes'].indexOf(attribute['taxonomyId'] + '') > -1 ||
                                            _this.activeFilters['attributes'].indexOf(attribute['taxonomyId']) > -1;
                                        expandSubcategory_1 = expandSubcategory_1 || isAttributeActive;
                                        attributeList_1.push({
                                            'name': attribute['attribute'],
                                            'id': attribute['taxonomyId'],
                                            'isActive': isAttributeActive
                                        });
                                    }
                                });
                            }
                            var isSubCategoryActive = _this.activeFilters['subcategories'].indexOf(subCategory['taxonomyId'] + '') > -1 ||
                                _this.activeFilters['subcategories'].indexOf(subCategory['taxonomyId']) > -1;
                            expandCategory = expandCategory || isSubCategoryActive || expandSubcategory_1;
                            subItemsList.push({
                                'name': subCategory['subCategory'],
                                'id': subCategory['taxonomyId'],
                                'isExpanded': expandSubcategory_1,
                                'isActive': isSubCategoryActive,
                                'hasAttribute': attributeList_1.length > 0,
                                'attribute': attributeList_1
                            });
                        }
                    });
                }
            });
            _this.filterModel['Categories']['items'].push({
                'name': _this.taxonomyMap.get(c.id),
                'id': c.id,
                'isExpanded': expandCategory,
                'isActive': _this.activeFilters['categories'].indexOf(c.id + '') > -1 ||
                    _this.activeFilters['categories'].indexOf(c.id) > -1,
                'hasSubItems': !!subItemsList.length,
                'subItems': subItemsList,
            });
            if (state['a'] || state['s'] || state['c'])
                _this.filterModel['Categories']['open'] = true;
        });
        facets['Brand'].forEach(function (brand) {
            _this.filterModel['Brand']['items'].push({
                'name': _this.brandMap.get(brand.id),
                'id': brand.id,
                'isActive': _this.activeFilters['brands'].indexOf(brand.id + '') > -1 ||
                    _this.activeFilters['brands'].indexOf(brand.id) > -1,
            });
        });
        facets['DietaryConsiderations'].forEach(function (dietaryConsideration) {
            _this.filterModel['DietaryConsiderations']['items'].push({
                'name': _this.dietaryConsiderationMap.get(dietaryConsideration.id),
                'id': dietaryConsideration.id,
                'isActive': _this.activeFilters['dietaryConsiderations'].indexOf(dietaryConsideration.id + '') > -1 ||
                    _this.activeFilters['dietaryConsiderations'].indexOf(dietaryConsideration.id) > -1,
            });
        });
        facets['Ingredients'].forEach(function (ingredient) {
            _this.filterModel['Ingredients']['items'].push({
                'name': _this.ingredientMap.get(ingredient.id),
                'id': ingredient.id
            });
            if (_this.activeFilters['excludeIngredients'].indexOf(ingredient.id + '') > -1) {
                _this.filterModel['Ingredients']['activeItems'].push({
                    'name': _this.ingredientMap.get(ingredient.id),
                    'id': ingredient.id
                });
            }
        });
        facets['ActiveIngredients'].forEach(function (activeIngredient) {
            _this.filterModel['ActiveIngredients']['items'].push({
                'name': _this.ingredientMap.get(activeIngredient.id),
                'id': activeIngredient.id
            });
            if (_this.activeFilters['includeIngredients'].indexOf(activeIngredient.id + '') > -1) {
                _this.filterModel['ActiveIngredients']['activeItems'].push({
                    'name': _this.ingredientMap.get(activeIngredient.id),
                    'id': activeIngredient.id,
                });
            }
        });
        facets['EqpStatus'].forEach(function (eqp) {
            _this.filterModel['EqpStatus']['items'].push({
                'name': eqp.value,
                'isActive': _this.activeFilters['eqpStatuses'].indexOf(eqp.value) > -1,
            });
        });
        facets['DeliveryFormat'].forEach(function (deliveryFormat) {
            _this.filterModel['DeliveryFormat']['items'].push({
                'name': _this.deliveryFormatMap.get(deliveryFormat.id),
                'id': deliveryFormat.id,
                'isActive': _this.activeFilters['deliveryFormat'].indexOf(deliveryFormat.id + '') > -1 ||
                    _this.activeFilters['deliveryFormat'].indexOf(deliveryFormat.id) > -1,
            });
        });
        facets['Dosage'].forEach(function (dosage) {
            _this.filterModel['Dosage']['items'].push({
                'name': dosage.value,
                'isActive': _this.activeFilters['dosages'].indexOf(dosage.value) > -1,
            });
        });
        var paramKeyValue;
        if (state.searchFilter) {
            paramKeyValue = this.getLandingSearchParamValue();
        }
        var landingPageFilters = {
            'a': 'Attribute',
            'b': 'Brand',
            'c': 'Categories',
            's': 'Subcategories',
            'q': 'EqpStatus'
        };
        // Expand filter panel if state is active
        Object.keys(this.filterModel)
            .forEach(function (key) {
            if (state[_this.filterModel[key]['stateParameter']] ||
                (paramKeyValue && key === landingPageFilters[paramKeyValue[0]])) {
                _this.filterModel[key]['displayNumber'] = _this.filterModel[key]['items'].length;
                _this.filterModel[key]['open'] = true;
            }
            if (paramKeyValue && (paramKeyValue[0] === 's' || paramKeyValue[0] === 'a') && key === 'Categories' &&
                _this.filterModel[key].items[0].subItems && _this.filterModel[key].items[0].subItems.length) {
                _this.filterModel[key]['displayNumber'] = _this.filterModel[key].items[0].subItems.length;
                _this.filterModel[key]['open'] = true;
            }
        });
        return this.filterModel;
    };
    /**
     * Request filter (id, name) list
     * @return {promise}
     */
    FilterService.prototype.getFilterMap = function () {
        var _this = this;
        return this.$q.all([
            this.ProductService.getTaxonomyMap(),
            this.ProductService.getBrands(),
            this.ProductService.getTaxonomies(),
            this.ProductService.getDietaryConsiderations(),
            this.ProductService.getDeliveryFormats(),
            this.ProductService.getIngredients(),
        ]).then(function (response) {
            _this.categoryList = response[0];
            _this.categoryList.forEach(function (category) {
                category.subCategory.forEach(function (subCategory) {
                    subCategory.attribute.forEach(function (attribute) {
                        _this.attributeSubcategoryLookup[attribute.taxonomyId] = subCategory.taxonomyId;
                    });
                    _this.subCategoryCategoryLookup[subCategory.taxonomyId] = category.taxonomyId;
                });
            });
            response[1].currentPage.forEach(function (brand) {
                _this.brandMap.set(brand.brandId, brand.brand);
            });
            response[2].forEach(function (taxonomy) {
                _this.taxonomyMap.set(taxonomy.taxonomyId, taxonomy.displayName);
            });
            response[3].currentPage.forEach(function (dietaryConsideration) {
                _this.dietaryConsiderationMap
                    .set(dietaryConsideration.dietaryConsiderationId, dietaryConsideration.consideration);
            });
            response[4].currentPage.forEach(function (deliveryFormat) {
                _this.deliveryFormatMap.set(deliveryFormat.deliveryFormatId, deliveryFormat.displayName);
            });
            response[5].currentPage.forEach(function (ingredient) {
                _this.ingredientMap.set(ingredient.ingredientId, ingredient.name);
            });
        });
    };
    FilterService.prototype.getLandingSearchParamValue = function () {
        var searchFilter = this.$stateParams.searchFilter;
        var paramKeyValue = searchFilter.substring(searchFilter.lastIndexOf('-') + 1).split('');
        paramKeyValue[0] = paramKeyValue[0].toLowerCase();
        paramKeyValue[1] = paramKeyValue.splice(1, paramKeyValue.length - 1).join('');
        return paramKeyValue;
    };
    FilterService.prototype.checkForLandingPageTransition = function (state) {
        if (state.hasOwnProperty('searchFilter')) {
            var paramKeyValue = this.getLandingSearchParamValue();
            state[paramKeyValue[0]] = [parseInt(paramKeyValue[1])];
            state['ff'] = parseInt(paramKeyValue[1]);
            state['fft'] = paramKeyValue[0];
            state['term'] = '*';
        }
    };
    return FilterService;
}());
export { FilterService };
//# sourceMappingURL=filter.service.js.map